import React from 'react';
import { Bar } from 'react-chartjs-2';

const TradeChart = () => {
  const data = {
    labels: ['Containerized', 'Dry Bulk', 'Liquid Bulk', 'Break Bulk'],
    datasets: [
      {
        label: 'Import',
        data: [58420, 42150, 22360, 4500],
        backgroundColor: '#4da6ff',
        borderColor: '#0a2c5e',
        borderWidth: 1
      },
      {
        label: 'Export',
        data: [27000, 20000, 6000, 5000],
        backgroundColor: '#4cd964',
        borderColor: '#2da63e',
        borderWidth: 1
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Tons'
        },
        grid: {
          color: 'rgba(0, 0, 0, 0.05)'
        }
      },
      x: {
        grid: {
          display: false
        }
      }
    },
    plugins: {
      legend: {
        position: 'top',
      }
    }
  };

  return <Bar data={data} options={options} />;
};

export default TradeChart;